// reverse mapping for VRS options categoryGroup to find-car list name for each option section in vrs duck
export default {
    Drivetrain: {
        listName: 'availableDriveTrainList',
        title: 'Drive Type',
    },
    Engine: {
        listName: 'availableEngineList',
        title: 'Engine',
    },
    Transmission: {
        listName: 'availableTransmissionList',
        title: 'Transmission',
    },
    ExteriorColors: {
        listName: 'exteriorColorList',
        title: 'Exterior Color',
    },
    InteriorColors: {
        listName: 'interiorColorList',
        title: 'Interior Color',
    },
    Packages: {
        listName: 'packageList',
        title: 'Packages',
    },
};
